import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../../../models/base/base-component';

@Component({
  selector: 'app-user-profile-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-profile-badge.component.html',
  styleUrls: ['./user-profile-badge.component.scss']
})
export class UserProfileBadgeComponent extends BaseComponent {
  @Input() public initials!: string;
  @Input() public textColor!: string;
  @Input() public isSPPBot: boolean = false;

  constructor() {
    super();
  }

  setupBindings(): void {}

  setupViews(): void {}
}
